import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PetServices {
  constructor(private http: HttpClient) {}

  private baseUrl = `${environment.Server_URL}/pet-services`;

  // ✅ Booking API
  private bookingUrl = `${environment.Server_URL}/pet-service-bookings`;

  /** 🟢 Get all pet services */
  getAll(page: number = 1, perPage: number = 10): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('per_page', perPage.toString());

    return this.http.get(this.baseUrl, { params });
  }
updateBookingStatus(id: number, data: any): Observable<any> {
  return this.http.post(`${this.bookingUrl}/${id}/status`, data);
}
  /** 🟢 Get single pet service */
  getById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  /** 🟢 Create new pet service */
  create(data: any): Observable<any> {
    return this.http.post(this.baseUrl, data);
  }

  /** 🟢 Update pet service */
  update(id: number, data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/${id}?_method=PUT`, data);
  }

  /** 🔴 Delete pet service */
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  getByWarehouse(
    warehouseId: number,
    page: number = 1,
    perPage: number = 10
  ): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('per_page', perPage.toString());

    return this.http.get(`${this.baseUrl}/warehouse/${warehouseId}`, { params });
  }

  // ==============================
  // ✅ Pet Service Bookings Methods
  // ==============================

  /** 🟢 Create booking */
  createBooking(data: any): Observable<any> {
    return this.http.post(this.bookingUrl, data);
  }

  /** 🟢 Get all bookings */
  getAllBookings(page: number = 1, perPage: number = 10): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('per_page', perPage.toString());

    return this.http.get(this.bookingUrl, { params });
  }

  /** 🟢 Get booking by id */
  getBookingById(id: number): Observable<any> {
    return this.http.get(`${this.bookingUrl}/${id}`);
  }

  /** 🟢 Get bookings by user */
  getBookingsByUser(
    userId: number,
    page: number = 1,
    perPage: number = 10
  ): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('per_page', perPage.toString());

    return this.http.get(`${this.bookingUrl}/user/${userId}`, { params });
  }

  /** 🔴 Delete booking */
  deleteBooking(id: number): Observable<any> {
    return this.http.delete(`${this.bookingUrl}/${id}`);
  }
}